module.exports = __webpack_public_path__ + "img/result-detail-output-inleft01.ec43504c.svg";